// Product Display System

jQuery('.controls a').click(function(evt) {
	evt.preventDefault();
	var imgPath = jQuery(this).attr('href');
	var oldImage = jQuery('#photo img');
	var newImage = jQuery('<img class="img-responsive media-object" src="' + imgPath +'">');
	newImage.hide();
	jQuery('#photo').prepend(newImage);
	newImage.fadeIn(1000);
	oldImage.fadeOut(1000,function(){
		jQuery(this).remove();
	});

	if(imgPath === "https://jumbobag.com/wp-content/uploads/sites/6/2022/07/upanel-bag.png") {
		console.log('upanel')
		jQuery('.heading').text('U-Panel');
		jQuery('.options').fadeIn(1000);
		jQuery('.options2').hide();
		jQuery('.options3').hide();
		jQuery('.options4').hide();
		} else if (imgPath === "https://jumbobag.com/wp-content/uploads/sites/6/2022/07/circular-bag.png") {
			console.log('circular')
			jQuery('.heading').text('Circular');
			jQuery('.options2').fadeIn(1000);
			jQuery('.options').hide();
			jQuery('.options3').hide();
			jQuery('.options4').hide();
		} else if (imgPath === "https://jumbobag.com/wp-content/uploads/sites/6/2022/07/4panel-bag.png") {
			console.log('4 panel')
			jQuery('.heading').text('4 Panel');
			jQuery('.options3').fadeIn(1000);
			jQuery('.options').hide();
			jQuery('.options2').hide();
			jQuery('.options4').hide();
		} else if (imgPath === "https://jumbobag.com/wp-content/uploads/sites/6/2022/07/baffle-bag.png") {
			console.log('baffle')
			jQuery('.heading').text('Baffle');
			jQuery('.options4').fadeIn(1000);
			jQuery('.options').hide();
			jQuery('.options2').hide();
			jQuery('.options3').hide();
		}
	}); // end click	
  
	jQuery('.controls a:first').click();